import { useEffect, useRef } from 'react';
import { TransactionStatus } from '../types';
import { depositStatusMap } from '../utils';
import { clearTransactionType, TRANSACTION_TYPE_DEPOSIT } from 'src/utils/transactionTypeFromLS';
import { useModalContext } from 'src/hooks/useModalContext';
import { useMessage } from 'src/modules/messages';
import { useTranslation } from 'react-i18next';

interface DepositRedirectType {
  status: TransactionStatus;
  operationType: string | null;
  isDepositType: boolean;
  merchantId: string | undefined;
}

export const useDepositRedirect = ({
  status,
  isDepositType,
  merchantId,
  operationType
}: DepositRedirectType) => {
  const { openModal } = useModalContext();
  const { openMessage } = useMessage();
  const { t } = useTranslation();
  const initialTypeRef = useRef(operationType);
  const isInitialDeposit = initialTypeRef.current === TRANSACTION_TYPE_DEPOSIT;

  useEffect(() => {
    if (isDepositType && isInitialDeposit) {
      clearTransactionType();
      openModal('LATEST_DEPOSIT', {
        props: { merchantId: status === 'success' || status === 'return' ? merchantId : undefined }
      });
    }
  }, [merchantId, status]);

  useEffect(() => {
    if (isDepositType && isInitialDeposit) {
      if (status === 'cancel') return undefined;
      const entry = depositStatusMap[status];
      if (entry) {
        openMessage({
          type: 'USER_MESSAGE',
          props: { text: t(entry.key), status: entry.status },
          saveToHistory: false
        });
      }
    }
  }, [status]);
};
